<template>
  <div class="v-header">
    <div class="toolbar">
      <div class="left">
        <img :src="logoSrc" alt="logo">
      </div>
      <div class="right">
        <community-btn />
        <notification :user="$user" />
      </div>
    </div>
    <div class="params">
      <smart-combobox
        key="0"
        :items="getSitesList"
        :label="$t('context.labels.site')"
        :value="getSiteLabel"
        icon="pin"
        placeholder="Choisissez votre site"
        @reset="onSiteReset"
        @select="onSiteSelected" />
      <smart-combobox
        v-if="mode === ModeEnum.RELIABILITY"
        key="1"
        :items="getSectorsList"
        :label="$t('context.labels.sector')"
        :value="getSectorLabel"
        :with-loader="false"
        icon="industrial"
        placeholder="Choisissez votre secteur"
        @reset="onSectorReset"
        @select="onSectorSelected" />
      <smart-combobox
        v-else-if="mode === ModeEnum.QUALITY"
        key="1"
        :items="getCustomersList"
        :label="$t('context.labels.customer')"
        :value="getCustomerLabel"
        icon="shop"
        placeholder="Choisissez votre client"
        @reset="onCustomerReset"
        @select="onCustomerSelected" />
        <smart-combobox
        v-else-if="mode === ModeEnum.MESH_QUALITY"
        key="1"
        :items="getCustomersList"
        :label="$t('context.labels.siteMesh')"
        :value="getMeshSiteLabel"
        icon="pin"
        placeholder="Choisissez votre site maillage"
        @reset="onMeshSiteReset"
        @select="onMeshSiteSelected" />
      <date-selector
        key="2"
        :disable-today="mode === ModeEnum.LEFTBEHIND"
        :mode="getDateMode"
        :value="period"
        @select="onPeriodSelected" />
    </div>
  </div>
</template>

<script>
  import CommunityBtn from '@/components/header/CommunityBtn'
  import DateSelector from '@/components/header/DateSelector'
  import Notification from '@/components/header/Notification'
  import SmartCombobox from '@/components/header/SmartCombobox'
  import {DATEMODES, ModeEnum} from '@/utils/consts'
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'VHeader',
    components: { SmartCombobox, DateSelector, Notification, CommunityBtn },
    async created() {
      await Promise.all([this.fetchSites(), this.fetchCustomers()])
    },

    computed: {
      ModeEnum() {
        return ModeEnum
      },
      ...mapGetters('context', ['site', 'meshSite', 'mode', 'sector', 'period', 'customer']),
      ...mapGetters('referential', ['sites', 'customers', 'meshSites']),

      getDateMode() {
        return this.mode === 'RELIABILITY' ? DATEMODES.WEEK : DATEMODES.DAY
      },

      getCustomerLabel() {
        return this.customer ? this.customer.label : ''
      },

      getCustomersList() {
        return this.customers ? this.customers.map(customer => customer.label) : []
      },

      getSiteLabel() {
        return this.site ? this.site.label + ' ' + this.site.id : ''
      },

      getMeshSiteLabel() {
          return this.meshSite ? this.meshSite.label : ''
      },

      getSitesList() {
        return this.sites ? this.sites.map(site => site.label + ' ' + site.id) : []
      },

      getSectorLabel() {
        if (this.site && this.site.sectors.length === 1) return this.site.sectors[0].label
        if (this.site && this.sector) return this.sector.label
        return ''
      },

      getSectorsList() {
        return this.site && this.site.sectors ? this.site.sectors.map(sector => sector.label) : []
      },

      logoSrc() {
        return require('@/assets/logo/logo.svg')
      }
    },

    methods: {
      ...mapMutations('context', ['SET_SITE', 'SET_SECTOR', 'SET_PERIOD', 'SET_CUSTOMER', 'SET_MESH_SITE']),
      ...mapActions('referential', ['fetchSites', 'fetchCustomers']),

      onSectorSelected(id) {
        this.SET_SECTOR(this.site.sectors[id])
      },

      onSectorReset() {
        this.SET_SECTOR(null)
      },

      onSiteSelected(id) {
        const selectedSite = this.sites[id]
        this.SET_SITE(selectedSite)
        this.SET_SECTOR(selectedSite.sectors.length > 1 ? null : selectedSite.sectors[0])
      },

      onSiteReset() {
        this.SET_SITE(null)
        this.SET_SECTOR(null)
      },

      onMeshSiteSelected(id) {
        this.SET_MESH_SITE(this.customers[id])
      },

      onMeshSiteReset() {
        this.SET_MESH_SITE(null)
      },

      onPeriodSelected(period) {
        this.SET_PERIOD(period)
      },

      onCustomerSelected(id) {
        this.SET_CUSTOMER(this.customers[id])
      },

      onCustomerReset() {
        this.SET_CUSTOMER(null)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-header {
    background: linear-gradient(to right, $light-red 0%, #89216B 100%);
    flex-direction: column;
    display: flex;

    .toolbar {
      padding: 0.5em 4rem 0 4rem;
      height: 40%;
      @include display-flex(center, space-between, row);

      .left {
        height: 100%;

        img {
          height: 100%;
          text-align: left;
        }
      }

      .right {
        display: flex;
        height: 100%;
        color: white;

        .community-button, .bell {
          margin-right: 2em
        }
      }
    }

    .params {
      flex: 1;
      @include display-flex(center, flex-start, row);
      width: 80%;
      padding: 1rem 0 1rem 4rem;

      .smart-combobox, .date-selector {
        max-height: 3.5em;
        max-width: 28.3rem;
      }
    }
  }
</style>
